export const getQuoteDiscountData = (state) => {
  return state.pages.quote.discounts;
};
